enum TEBadgeSignal {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Brand = 'brand',
  Neutral = 'neutral',
  NeutralInverse = 'neutral-inverse',
  Dot = 'dot',
  Number = 'number',
}

export default TEBadgeSignal;
